import styled from 'styled-components';

export const Logo = styled.img`
  width: 287px;
  height: 66px;
  margin: 0 auto;
  display: flex;
  align-items: center;
`;
